import { useFormik } from "formik";
import Button from "../../../components/buttons/button";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import Select from "../../../components/select/select";
import * as yup from "yup";
import TimeInput from "../../../components/inputs/timeInput";
const WorkTimeSetup = ({ t, setOpen }) => {
  const validationSchema = yup.object({
    day: yup.string().required(t("required")),
    start: yup.string().required(t("required")),
    end: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      day: "",
      start: "",
      end: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });

  const { daysOptions } = useOptions();
  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div className="inputs">
        <Select options={daysOptions} formik={formik} name={"day"} label={t("day")} />
      </div>

      <div className="inputs">
        <TimeInput formik={formik} name={"start"} label={t("checkInTime")} />
        <TimeInput formik={formik} name={"end"} label={t("checkOutTime")} />
      </div>

      <div className="flex items-center justify-end gap-3">
        <Button
          className={"bg-primary justify-center w-[130px] text-[#1F384C] text-sm"}
        >
          {t("confirm")}
        </Button>
        <Button
          className={"border border-[#C42E27] text-[#C42E27] text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
    </form>
  );
};

export default WorkTimeSetup;
